<template>
    <v-layout>
        <v-flex xs12 sm12 md12 lg12  v-if="isLoadingMember == false">
            <v-card>
                <div>
                    <v-img class="white--text cover-img" :src="(member.coverImg)?member.coverImg:'https://cdn.vuetifyjs.com/images/cards/docks.jpg'"  v-if="!isUploadingCoverImg">  
                        <span class="float-right marR10 marT18 pointer cover-style" v-if="canUpdateProfile"  @click="launchFilePicker('cover')" >
                            <i class="material-icons fntS40 cover-upload-icon">camera_alt</i>
                            Upload Cover Photo
                        </span>
                    </v-img>
                    <v-progress-circular v-if="isUploadingCoverImg"
                        :rotate="360"
                        :size="100"
                        :width="15"
                        :value="imageUploadProgress"
                        color="#ffa300"
                    >{{ imageUploadProgress }}</v-progress-circular>
                </div>
                <v-card-text class="padB0">
                    <v-layout slot="header" align-left row spacer>
                        <v-flex sm2 md2 lg2 class="bckWht">
                            <div class="float-left">  
                                <v-avatar class="float-left avatar-img positionAbsolute">
                                    <v-img :src="(member.avatar)? member.avatar.defaultSrc : defaultAvatarSrc" v-if="!isUploadingAvatarImg"></v-img>
                                    <i class="material-icons pointer uploadbckBlck fntS40 profile-upload-icon" @click="launchFilePicker('profile')" v-if="canUpdateProfile">camera_alt <p class="camera-p" >UPDATE</p></i>
                                </v-avatar>   
                                <v-progress-circular v-if="isUploadingAvatarImg"
                                        :rotate="360"
                                        :size="100"
                                        :width="15"
                                        :value="imageUploadProgress"
                                        color="#ffa300"
                                        class="avatar-progress"
                                >{{ imageUploadProgress }}                                    
                                </v-progress-circular>
                                <!-- <span class="positionAbsolute clrLBlue upload-span pointer" @click="launchFilePicker('profile')"> UPLOAD PHOTO </span> -->
                                <input type="file" ref="file" :name="uploadFieldName" @change="fileChange($event.target)" class="disNone">
                            </div>
                        </v-flex>
                        <v-flex sm10 md10 lg10 class="mar1per bckWht mar6 detail-section">
                            <i class="material-icons clrLBlue icon-20 float-right pointer" v-if="canUpdateProfile" @click="isChangeAbout=!isChangeAbout">edit</i>
                            <div class="text-left">                                    
                               
                                <h4 class="fntWht800 fntSxLrg"> 
                                    {{member.firstName}} {{member.lastName}} 
                                    <!-- <i class="material-icons clrLBlue icon-20" v-if="canUpdateProfile">edit</i> -->
                                </h4>
                                <h5 class="clrLBlue"> 
                                    <!-- <i class="material-icons">error_outline</i> {{member.occupation}}  -->
                                </h5> 
                                <h4>{{member.profesion}}</h4>
                                <h4>{{member.about}}</h4>                                
                                 
                                <!-- <i class="material-icons clrLBlue icon-20" v-if="canUpdateProfile">edit</i> -->
                                <span>
                                    <v-text-field name="profesion" label="WHAT IS YOUR PROFESION?" v-model="member.profesion" v-if="isChangeAbout"></v-text-field>
                                    <v-textarea name="about" label="TELL US ABOUT YOU" v-model="member.about" v-if="isChangeAbout"></v-textarea>
                                    <v-btn v-if="isChangeAbout" block color="success" @click="updateProfile()">Update</v-btn>
                                </span>
                                
                                <div class="marAuto">
                                    <a v-bind:href="member.socialTwitter" target="_blank">
                                        <i class="fa fa-twitter-square social-font hgt50 mar5" alt="linkedin_icon" v-if="member.socialTwitter"></i>
                                    </a>                                    
                                    <a v-bind:href="member.socialFacebook" target="_blank">
                                        <i class="fa fa-facebook-official social-font hgt50 mar5" alt="facebook_icon" v-if="member.socialFacebook"></i>
                                    </a>
                                    
                                    <a v-bind:href="member.socialInsta" target="_blank">
                                        <i class="fa fa-instagram social-font hgt50 mar5" alt="instagram_icon" v-if="member.socialInsta"></i>
                                     </a>
                                     <a v-bind:href="member.socialWebsite" target="_blank">
                                        <i class="fa fa-globe social-font hgt50 mar5" alt="instagram_icon" v-if="member.socialWebsite"></i>
                                     </a>
                                </div>
                            </div>

                            <v-flex sm12 md12 lg12>
                                <hr />
                                <v-layout>
                                    <v-flex xs12 sm6 md6 lg6 class="mar1per bckWht mar6 detail-section">
                                        <h3>Social pages</h3>
                                        <v-text-field name="city" label="Twitter" v-model="member.socialTwitter" required @input="validateMemberDetails" :disabled="!canUpdateProfile"></v-text-field>

                                        <v-text-field name="state" label="Facebook" v-model="member.socialFacebook" required @input="validateMemberDetails" :disabled="!canUpdateProfile"></v-text-field>

                                        <v-text-field name="zip" label="Instagram" v-model="member.socialInsta" required @input="validateMemberDetails" :disabled="!canUpdateProfile"></v-text-field>
                                       
                                        <v-text-field name="zip" label="Website" v-model="member.socialWebsite" required @input="validateMemberDetails" :disabled="!canUpdateProfile"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 class="mar1per bckWht mar6 detail-section">
                                        <h3>Directory information</h3>
                                        <v-text-field name="firstName" label="First name*" v-model="member.firstName" :rules="directoryRules.firstName" required @input="validateMemberDetails" 
                                        @keypress="onlyCharacter" :disabled="!canUpdateProfile"></v-text-field>
                                        <v-text-field name="lastName" label="Last name*" v-model="member.lastName" :rules="directoryRules.lastName" required @input="validateMemberDetails" @keypress="onlyCharacter" :disabled="!canUpdateProfile"></v-text-field>
                                        <v-text-field name="city" label="City*" v-model="member.city" :rules="directoryRules.city" required @input="validateMemberDetails" @keypress="onlyCharacter" :disabled="!canUpdateProfile"></v-text-field>

                                        <v-select
                                            :items="stateItems"
                                            v-model="member.state"
                                            :rules="directoryRules.state"
                                            label="State"
                                            item-value="value"
                                            required
                                            @change="validateMemberDetails"
                                            :disabled="!canUpdateProfile"
                                        ></v-select>
<!-- 
                                        <v-text-field name="state" label="State*" v-model="member.state" :rules="directoryRules.state" required @input="validateMemberDetails" @keypress="onlyCharacter" :disabled="!canUpdateProfile"></v-text-field> -->

                                        <v-text-field name="zip" label="Zip*" v-model="member.zip" :rules="directoryRules.zip" required @input="validateMemberDetails" :disabled="!canUpdateProfile"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-btn v-if="canUpdateProfile" block color="info" class="mar0" @click="updateProfile()" :disabled="!isValidMemberDetail">Update</v-btn>
                            </v-flex>
                            <v-flex sm12 md12 lg12 class="text-left" v-if="canUpdateProfile">
                                <hr />
                                <h3>Registration information</h3>
                                
                                <v-form ref="form">
                                    <v-layout>
                                    <v-flex xs11 sm11 md11 lg11>
                                        <v-text-field
                                            v-model="passwordForm.email" 
                                            @input="validatePasswordForm"
                                            :rules="memberRules.email"
                                            label="Email*"
                                            type="text"
                                            :disabled="!isChangeEmail"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs1 sm1 md1 lg1>
                                        <i class="material-icons pointer text-right float-right" @click="isChangeEmail = !isChangeEmail">edit</i>
                                    </v-flex>
                                    </v-layout>
                                    <v-text-field
                                        :type="'password'"
                                        v-model="passwordForm.currentPass"
                                        label="Current password*"
                                        :rules="memberRules.password"
                                        @input="validatePasswordForm"
                                        :disabled="!canUpdateProfile"
                                    ></v-text-field>
                                    <v-text-field
                                        label="New password" 
                                        :type="'password'"
                                        v-model="passwordForm.newPass" 
                                        :rules="memberRules.password"
                                        @input="validatePasswordForm"
                                        :disabled="!canUpdateProfile"
                                        v-if="!isChangeEmail"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="passwordForm.confirmPass"
                                        :type="'password'"
                                        label="New password again" 
                                        :rules="memberRules.cpassword"
                                        @input="validatePasswordForm"
                                        :error-messages='passMatchError()'
                                        :disabled="!canUpdateProfile"
                                        v-if="!isChangeEmail"
                                    ></v-text-field>
                                    <v-btn v-if="canUpdateProfile" block color="success" @click="updatePassword()" :disabled="(!isValidPasswordForm) ? true : false">Update</v-btn>
                                </v-form>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <div>
                            <v-tabs slider-color="#ffa300">
                                <v-tab ripple>
                                    ALL 
                                </v-tab>
                                <v-tab ripple>
                                    <i class="material-icons marR10">
                                        message
                                    </i> NEWS
                                </v-tab>
                                <v-tab ripple>
                                    <i class="material-icons marR10">
                                        event
                                    </i> EVENTS
                                </v-tab>
                                <v-tab ripple>
                                    <i class="material-icons marR10">
                                        supervisor_account
                                    </i> MEMBERS
                                </v-tab>
                                <v-tab ripple>
                                    <i class="material-icons marR10">
                                        pool
                                    </i> STORIES
                                </v-tab>
                                <v-tab ripple>
                                    <i class="material-icons marR10">
                                        child_care
                                    </i> DISCUSS
                                </v-tab>
                                <v-tab-item style="background-color: transparent;">
                                    <v-card flat>
                                        <v-card-text> ALL </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item style="background-color: transparent;">
                                    <v-card flat>
                                        <v-card-text> NEWS </v-card-text>
                                    </v-card>
                                </v-tab-item>  
                                <v-tab-item>
                                    <div v-for="(props, i) in events" :key="i">
                                        <events-item :props="props"> </events-item>
                                    </div>
                                </v-tab-item>  
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text> MEMBERS </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text> STORIES </v-card-text>
                                    </v-card>
                                </v-tab-item>  
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text> DISCUSS </v-card-text>
                                    </v-card>
                                </v-tab-item>  
                            </v-tabs>
                        </div>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-layout row v-else>
            <v-flex class="text-xs-center">
                <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-layout> 
</template>

<script>
    import UserService from "@/services/db/UserService.js";
    import CONSTANT from "@/services/Constant.js";
    import Utils from "@/services/Utils.js";
    import EventService from "@/services/db/EventService.js";
    import SettingService from "@/services/db/SettingService.js";
    // import EventItem from "../member/events/events-item.vue";
    import EventItem from "../events/events-item/events-item.vue";
    import firebase from "firebase";

    export default {
        name: "Members-Detail",
        props: ["id"],
        components: {
          "events-item": EventItem
        },
        data(){
            return {
                member: {"profesion":"","about":"","socialTwitter": "", "socialFacebook": "", "socialInsta": "", "socialWebsite": "","firstName":"","lastName":"","city":"","state":"","zip":""},
                events: [], 
                passMatchFlag: false, 
                uploadFieldName: "file", 
                passwordForm:{"email": "", "newPass":"","confirmPass":"","currentPass":""},
                isValidPasswordForm: false,
                imageUploadProgress:100,
                isLoadingMember: false,
                isUploadingAvatarImg: false,
                isUploadingCoverImg: false,
                defaultAvatarSrc: CONSTANT.DEFAULTS.defaultAvatarSrc,
                imgId: false,
                timeStamp: "",
                fileType: "",
                imageName: "",
                imageUrl: "",
                imageFile: "",
                active: null,
                isValidMemberDetail: false,
                isChangeEmail: false,
                isChangeAbout: false,
                text: '',
                stateItems: [],
                memberRules: {
                    email: [
                        v => !!v || "E-mail is required",
                        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                            "E-mail must be valid"
                    ],
                    password: [
                        v => (v && v.length >= 8) || "Password must be atleast 8 characters"
                    ],
                    cpassword: [
                        v => (v && v.length >= 8) ||
                            "Confirm Password must be atleast 8 characters"
                    ]
                },
                directoryRules: {
                    firstName: [
                        v => !!v || "First name is required (No special character and number allowed)"
                    ],
                    lastName: [
                        v => !!v || "Last name is required (No special character and number allowed)"
                    ],
                    city: [
                        v => !!v || "City is required (No special character and number allowed)"
                    ],
                    state: [
                        v => !!v || "State is required (No special character and number allowed)"
                    ],
                    zip: [
                        v => !!v || "Zip name is required"
                    ],
                },
                currentMemberEmail: ""
            }
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
            disNoneUpMdClass(){
                return { 
                    "disNone":this.$vuetify.breakpoint.mdAndUp
                }
            },
            disNoneClass(){
                return {
                    "disNone":this.$vuetify.breakpoint.smAndDown
                }
            },
            canUpdateProfile(){
                var _USER = JSON.parse(this.$store.getters.loginUser);
                return (_USER && this.member.userId === _USER.userId)? true : false;
            }
        }, 

        created() { 
            if (this.id) {
                this.getMemberDetails(this.id);
                this.loadEventsByMemberId(this.id);
            }
            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.STATE_LIST);
        },

        methods: {
            /*
            * Method to validate member password form
            */
            validatePasswordForm() {
                if (
                    !this.passwordForm ||
                    (!Utils.isValidEmail(this.passwordForm.email) ||
                    !this.passwordForm.currentPass ||
                    this.passwordForm.currentPass.length < 8 ||
                    (!this.isChangeEmail && (this.passwordForm.newPass.length < 8 ||
                    this.passwordForm.confirmPass.length < 8 ||
                    this.passwordForm.newPass != this.passwordForm.confirmPass)))
                ) {
                    this.isValidPasswordForm = false;
                } else {
                    this.isValidPasswordForm = true;
                }
            },

            // --------------------
            // Method to load setting value by key
            // --------------------
            loadSettingsByKey(key){

                SettingService.getSettingByKey(key).then((setting) => {
                    if(setting){
                        if(key == CONSTANT.APP_SETTING_KEYS.STATE_LIST){
                            this.stateItems = setting['US'];
                        }
                    }
                });
            },

            /*
            * Method to match password
            */
            passMatchError () { 
                if(this.passwordForm.confirmPass == ''){
                    return ''
                } else {
                    if(this.passwordForm.confirmPass === this.passwordForm.newPass){
                        this.passMatchFlag = true;
                        return ''
                    } else {
                        this.passMatchFlag = false;
                        return 'Password must match'
                    } 
                }
            },

            /*
            * Method to validate member details
            */
            validateMemberDetails(){
                if (
                    !this.member ||
                    !this.member.city ||
                    !this.member.state ||
                    !this.member.zip ||
                    (this.member.socialTwitter && !Utils.isValidURL(this.member.socialTwitter)) ||
                    (this.member.socialFacebook && !Utils.isValidURL(this.member.socialFacebook)) || 
                    (this.member.socialInsta && !Utils.isValidURL(this.member.socialInsta)) || 
                    (this.member.socialWebsite && !Utils.isValidURL(this.member.socialWebsite))
                ) {
                    this.isValidMemberDetail = false;
                } else {
                    this.isValidMemberDetail = true;
                }
            },

            /*
            * Method to update password
            */
            updatePassword(){
                var userInfoModel = {
                    "email": this.currentMemberEmail,
                    "password":this.passwordForm.currentPass
                }

                UserService.firebaseSignInWithEmailAndPassword(userInfoModel).then((user) => {
                    if(user.code){
                        this.$store.commit('setAlert', {isAlertError: true, message: (user.code == CONSTANT.MESSAGES.FIREBASE.CODE_USER_NOT_FOUND)? CONSTANT.MESSAGES.FIREBASE.USER_NOT_FOUND : CONSTANT.MESSAGES.FIREBASE.WRONG_PASSWORD });
                        this.isLogin = false;
                    } else {
                        let currentUser = firebase.auth().currentUser;

                        if(this.isChangeEmail){
                            this.updateMemberEmail(user);
                        } else {
                            this.updateMemberPassword(currentUser);
                        }
                    }
                })
            },

            /*
            * Method to update password in firebase auth
            */
            updateMemberPassword(user){
                user.updatePassword(this.passwordForm.newPass).then(() => {

                    // Update successful.
                    this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.USER.UPDATE_PASSWORD_SUCCESS });

                    this.passwordForm = {"email": this.passwordForm.email, "newPass":"","confirmPass":"","currentPass":""}

                }, () => {
                    // An error happened.
                    this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.USER.UPDATE_PASSWORD_FAIL});
                });
            },

            /*
            * Method to update member email in firebase auth
            */
            updateMemberEmail(userCredential){
                if(this.currentMemberEmail != this.passwordForm.email){
                    userCredential.user.updateEmail(this.passwordForm.email).then(() => {
                        
                        this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.USER.UPDATE_EMAIL_SUCCESS });

                        this.updateMemberInDataBase(this.passwordForm.email);
                        this.passwordForm = {"email": this.passwordForm.email, "newPass":"","confirmPass":"","currentPass":""}
                        this.isChangeEmail = false;

                    }, (userError) => {
                        // An error happened.
                        this.$store.commit('setAlert', {isAlertError: true, message: userError.message });
                    });
                } else {
                    this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.USER.EMAIL_DOESNOT_CHANGED }); 
                }
            },

            /*
            * Method to update profile
            */
            updateMemberInDataBase(email){
                var _USER = JSON.parse(this.$store.getters.loginUser);

                UserService.getUserById(_USER.userId).then(user => {
                    var userModel = Object.assign({}, user);
                    userModel['email'] = email;

                    UserService.addNewUser(userModel, user.userId)
                        .then(() => {
                            setTimeout(() => {
                                this.forceLogout();
                            }, 1000);
                            // localStorage.setItem(CONSTANT.LOCAL_STORAGE.LOGIN_USER, JSON.stringify(Utils.getShortUserDetail(userModel)));
                            // this.currentMemberEmail = email;
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED_FAIL
                        });
                    });
                });
            },

            forceLogout() {
                UserService.firebaseSignOut()
                .then(() => {
                    this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.USER.LOGOUT_SUCCESS
                    });
                    setTimeout(() => {
                        localStorage.removeItem("token");
                        localStorage.removeItem("mealLoginUser");
                        location.href = '/login';
                        window.location.reload();
                    }, 1000);
                })
                .catch(() => {
                    this.$store.commit("setAlert", {
                        isAlertError: true,
                        message: CONSTANT.MESSAGES.USER.LOGOUT_FAIL
                    });
                });
            },

            /*
            * Method to called when profile or cover image selection change
            */
            fileChange(event){
                var files = event.files;
                var type = "image";
                if (files[0] !== undefined) {
                    if(this.fileType == 'profile'){
                        this.isUploadingAvatarImg = true;
                    } else if(this.fileType == 'cover'){
                        this.isUploadingCoverImg = true;
                    }
                    var _name = files[0].name;
                    if (_name.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        if (type == "image") {
                            this.imageName = _name;
                            this.imageFile = files[0];
                        }
                        this.uploadImg(type);
                    });
                }
            },

            /*
            * Method to upload image to firebase storage
            */
            uploadImg(type){
                if (this.imageFile) {
                    var _name = this.imageName;
                    this.isUploadingImage = type == "image" ? true : false;

                    var imgReff;

                    if(this.fileType == 'profile'){
                        imgReff = CONSTANT.FIREBASE_STORAGE.MEMBERS;
                    } else {
                        imgReff = CONSTANT.FIREBASE_STORAGE.MEMBERS+CONSTANT.FIREBASE_STORAGE.COVER_IMAGES;
                    }
                    this.timeStamp = Utils.getTimestampByDate();
                    if (this.imgId) {
                        imgReff = imgReff + this.imgId + "/" + this.timeStamp + _name;
                    } else {
                        this.imgId = Utils.generateUUID();
                        this.id = this.imgId;
                        imgReff = imgReff + this.imgId + "/" + this.timeStamp + _name;
                    }
                    var storageRef = firebase.storage().ref(imgReff);

                    var uploadTask = storageRef.put(this.imageFile);

                    uploadTask.on("state_changed", snapshot => {
                        var progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2);
                        this.imageUploadProgress = parseInt(type == "image" ? progress : 0);
                    }, () => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: this.id
                                ? CONSTANT.MESSAGES.EVENT.UPDATE_FAIL
                                : CONSTANT.MESSAGES.EVENT.UPLOAD_FAIL
                        });
                    }, () => {
                        // Upload complete
                        storageRef.getDownloadURL().then(url => {
                            if(this.fileType == 'profile'){
                                this.member.avatar = {};
                                this.member.avatar.defaultSrc = url;
                            } else {
                                this.member.coverImg = url;
                            }  

                            UserService.addNewUser(this.member, this.member.userId)
                            .then(() => {
                                this.isUploadingAvatarImg = false;
                                this.isUploadingCoverImg = false;
                                // callback(null, _user);
                                this.$store.commit("setAlert", {
                                    isAlertSuccess: true,
                                    message: CONSTANT.MESSAGES.EVENT.IMAGE_UPLOAD_SUCCESS
                                });  
                            })
                            .catch(() => {
                                    this.isUploadingAvatarImg = false;
                                    this.isUploadingCoverImg = false;
                                    // console.log("error" + JSON.stringify(error));
                                    // callback(error, null);
                                    this.$store.commit("setAlert", {
                                        isAlertSuccess: true,
                                        message: CONSTANT.MESSAGES.EVENT.UPLOAD_FAIL
                                    });
                                });
                            });
                        }
                    );
                }
            },

            /*
            * Method to update profile
            */
            updateProfile(){
                
                UserService.addNewUser(this.member, this.member.userId)
                    .then(() => {
                        this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED
                    });
                    this.isChangeAbout = false;
                })
                .catch(() => {
                    this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED_FAIL
                    });
                });
            },

            // launch file picker
            launchFilePicker(type) {
                if(this.canUpdateProfile){
                    this.fileType = type;
                    this.$refs.file.click();
                }
            },

            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            },

            /*
            * Method to get member detail
            */
            getMemberDetails() {
                this.isLoadingMember = true;
                UserService.getUserById(this.id).then(getUser => { 
                    this.member = getUser;
                    this.passwordForm.email = this.currentMemberEmail = this.member.email;
                    this.isLoadingMember = false;
                    this.checkUserRole();
                })
                .catch( ()=> {
                    // console.log({e});
                });
            },

            /*
            * Method to load events of member
            */
            loadEventsByMemberId() {
                EventService.getEvents(
                    this.id,
                    events => {
                        this.events = [];

                        if (events) {
                            events.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                this.events.push(_obj);
                            });
                        }

                    }
                );
            },

            onlyCharacter($event) {
                Utils.onlyCharacter($event);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.social-font{
    font-size: 30px;
    color:#94a9c3;
}
.cover-style{
    font-family: none;
    height: 24px;
    width: 148px;
    border: 1px solid #ffffff;
}
.uploadbckBlck{
    background-color: rgba(0,0,0,10);
    width: 130px;
    height: 67px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    border: 1px solid gray;
    border-left: 0;
    
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.cover-style{
    display: none;
}
.cover-upload-icon{ 
    /* display: none;  */
    font-size: 21px;
    color:#ffff;   
}
.cover-img:hover .cover-style{
    opacity: 10;
    display: block;
    background-color: rgba(0,0,0,0.3);
} 
.profile-upload-icon{
    display: none;
    color:#ffff;
    position: absolute !important;
    top: 0px!important;
    padding-top: 5px;
    font-size: 25px!important;
}
.avatar-img{
    border: 70px solid #ffffff;
    display: inline-flex;
}
.avatar-img:hover .profile-upload-icon{ 
    opacity: 0.7;
    display: block;
}
.avatar-progress{
    height: 135px !important;
    width: 130px !important;
    position: absolute;
    top: 125px;
    left: 20px;
}
/* .camera-p p:first-letter{
    text-transform: uppercase;
} */
.camera-p{
    font-size: 12px;
    /* text-transform: lowercase; */
}

</style>
